import React from 'react'
import { List, Header } from 'semantic-ui-react'

const ZimWaves = () => (
  <List divided relaxed>
    <Header as="h3" textAlign="center">Please select the version you would like to download</Header>
    <List.Item>
      <List.Content>
        <List.Header href="https://rebrand.ly/zimwaves_v1-2-0" target="_blank" as='a'>Zim Waves version 1.2.0</List.Header>
        <List.Description as='a'>Uploaded on 23 June 2019</List.Description>
      </List.Content>
    </List.Item>
    <List.Item>
      <List.Content>
        <List.Header href="https://rebrand.ly/zimwaves_v1-0-1" target="_blank" as='a'>Zim Waves version 1.0.1</List.Header>
        <List.Description as='a'>Uploaded on 5 June 2019</List.Description>
      </List.Content>
    </List.Item>
    <List.Item>
      <List.Content>
        <List.Header href="http://bit.ly/zimwaves_v1" target="_blank" as='a'>Zim Waves version 1.0.0</List.Header>
        <List.Description as='a'>Uploaded on 10 May 2019</List.Description>
      </List.Content>
    </List.Item>
  </List>
)

export default ZimWaves